import { xaiModels } from './models/xai';
import { ideogramModels } from './models/ideogram';
import { openaiModels } from './models/openai';
import { fluxModels } from './models/flux';
import { kreaModels } from './models/krea';
import { microsoftModels } from './models/microsoft';
import { lumaModels } from './models/luma';
import { nvidiaModels } from './models/nvidia';
import { googleModels } from './models/google';
import { volcengineModels } from './models/volcengine';
import { recraftModels } from './models/recraft';
import { alibabaModels } from './models/alibaba';
import { midjourneyModels } from './models/midjourney';
import { klingModels } from './models/kling';
import { miscModels } from './models/misc';
import { flowmuseModels } from './models/flowmuse';
import { topazModels } from './models/topaz';
import { reveModels } from './models/reve';
import type { TersaImageModel } from './types';
import { withModelIds } from '../shared/with-model-ids';
import { getModelIdsByTag } from '../shared/utils';
import { threedModels } from './models/threed';

export { getEffectiveResolutions, getEffectiveImageConfig, getEffectiveImagePrecheck, resolveImageMode } from './types';
export type { ImageSize, TersaImageModel, ImageModeKey, ImageModeConfig, EffectiveImageConfig } from './types';

export const imageModels: Record<string, TersaImageModel> = withModelIds({
  ...xaiModels,
  ...ideogramModels,
  ...openaiModels,
  ...fluxModels,
  ...kreaModels,
  ...microsoftModels,
  ...lumaModels,
  ...nvidiaModels,
  ...googleModels,
  ...volcengineModels,
  ...recraftModels,
  ...alibabaModels,
  ...midjourneyModels,
  ...klingModels,
  ...miscModels,
  ...flowmuseModels,
  ...topazModels,
  ...reveModels,
  // ...threedModels,
});

/**
 * 图像功能入口使用的 tag 约定：UI（顶部工具栏 / 重绘弹窗等）通过这些 tag
 * 从模型注册表动态解析可用模型，新增/下线模型只需改模型配置的 tags。
 */
export const IMAGE_MODEL_TAGS = {
  /** 画质增强（超分） */
  upscale: 'image-upscale',
  /** 一键抠图（移除背景） */
  removeBackground: 'image-remove-background',
  /** 比例重构（reframe / outpaint） */
  reframe: 'image-reframe',
  /** 图像处理（锐化/修复/光照/降噪等效果类） */
  effects: 'image-effects',
  /** 图像重绘（画笔勾选区域 inpaint） */
  inpaint: 'image-inpaint',
} as const;

/** 按 tag 返回图像模型 ID 列表（保持注册表声明顺序） */
export const getImageModelIdsByTag = (tag: string): string[] =>
  getModelIdsByTag(imageModels, tag);